import {observable, action} from 'mobx';
import localeText from '@locale';
import axiosInstance, {downloadFile} from '~/utils/axiosInstance';
import uris from '~/uris';

const supportType = 'application/vnd.ms-excel;charset=utf-8';

class UploadStore {
  @observable records = [];

  @action('下载用户模板的请求')
  downloadTemplate() {
    return downloadFile(uris.downloadUserTemplate()).then((response) => {
      this.downloadFile(response, `${localeText('USER.TITLE_TEMPLATE_NAME')}`);
    });
  }

  // 下载文件，输入data，和命名的文件名
  downloadFile(res, filename) {
    const blob = new Blob([res], {type: supportType});
    if (window.navigator.msSaveBlob) { // IE
      return window.navigator.msSaveOrOpenBlob(blob, `${filename}`);
    }
    const fileURL = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(fileURL);
  }

  @action('上传导入用户文件的请求')
  uploadUserTemplate(file) {
    const str = (new Date()).toString();
    const index = str.indexOf('GMT');
    const zone = str.substr(index + 3, 5);

    return axiosInstance
      .post(uris.uploadUsersTemplate(), file, {
        params: {
          zone
        },
        headers: {
          'content-type': 'multipart/form-data'
        },
        showError: {
          show: true,
          showPopup: true,
          title: localeText('USER.TITLE_UPLOAD_FILE_ERROR')
        }
      })
      .catch(e => Promise.reject(e));
  }

  @action
  getImportRecords() {
    return axiosInstance
      .post(uris.uploadHistoryRecord(), {
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        this.setRecords(response.records);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  @action('set records')
  setRecords(data) {
    this.records = data;
  }

  @action('下载失败记录文件')
  downloadRecord(id) {
    return downloadFile(uris.downloadFailedRecord(), {
      params: {
        recordId: id
      }
    })
      .then((response) => {
        this.downloadFile(response, `${localeText('USER.TITLE_HISTORY_RECORDS_NAME', new Date().toISOString().substring(0, 10))}`);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  @action('向后台轮询是否处理完毕,获取单条历史纪录')
  getImportRecord(id) {
    return axiosInstance
      .get(uris.signalHistoryRecord(), {
        params: {
          recordId: id
        },
        showError: false
      })
      .catch((e) => {
        console.log(e);
      });
  }
}

export default new UploadStore();
